import type { IconNode } from '../types';

/**
 * @name sausage
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjIgMTlhMyAzIDAgMSAxLTYgMEExMSAxMSAwIDAgMCA1IDhhMyAzIDAgMSAxIDAtNiAxNyAxNyAwIDAgMSAxNyAxNyIgLz4KICA8cGF0aCBkPSJNMTIuOCAxMS4yIDIgMjIiIC8+CiAgPHBhdGggZD0ibTkuMiA4LjgtMi41IDIuNWEzLjEgMy4xIDAgMCAwIDAgNC4ybDEuOCAxLjhhMy4xIDMuMSAwIDAgMCA0LjIgMGwyLjUtMi41IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/sausage
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const sausage: IconNode = [
  [
    'path',
    { d: 'M22 19a3 3 0 1 1-6 0A11 11 0 0 0 5 8a3 3 0 1 1 0-6 17 17 0 0 1 17 17', key: 'okqsz6' },
  ],
  ['path', { d: 'M12.8 11.2 2 22', key: 'a53jcc' }],
  [
    'path',
    {
      d: 'm9.2 8.8-2.5 2.5a3.1 3.1 0 0 0 0 4.2l1.8 1.8a3.1 3.1 0 0 0 4.2 0l2.5-2.5',
      key: 'u0qojg',
    },
  ],
];

export default sausage;
